import styled from "styled-components";
import SimpleBar from 'simplebar-react';

export const CastlePageWrapper = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  display: flex;
  flex-direction: row;
  margin: 0 auto;
  width: 1450px;
  animation: slideUp 2s ease-in-out forwards;

  @keyframes slideUp {
    from {
      top: 150%;
    }
    to {
      top: 50%;
    }
  }

  &.part-2 {
    align-items: center;
  }

  @media (max-width: 1024px) {
    width: 95vw;
  }
`;


export const LeftWrapper = styled.div`
  border-radius: 10px;
  z-index: 100;
  position: relative;

  @media (max-width: 1024px) {
    width: 35%;
  }
`;


export const RightWrapper = styled.div`
  background-color: var(--bg-light-blue);
  border-radius: 10px;
  margin-left: -16px;
  height: 720px;
  display: flex;
  flex-direction: column;

  @media (max-width: 1024px) {
    width: 65%;
    margin-left: 10px;
  }
`;


export const ImageGallery = styled.img`
  width: 500px;
  height: 717px;
  object-fit: cover;
  border-radius: 10px;
  border: 2px solid var(--highlight);

  @media (max-width: 1024px) {
    width: 100%;
    margin-left: 10px;
  }
`;



export const Magnifier = styled.img`
  position: absolute;
  z-index: 100;
  top: 20px;
  left: 20px;
  cursor: pointer;
`;


export const Bullets = styled.div`
  cursor: pointer;
  position: absolute;
  z-index: 1000;
  bottom: 50px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 15px;
  width: 95%;

  /* Specific style override for part-2 */
  .part-2 & {
    bottom: 20px;
    width: 90%;
  }
`;

export const Bullet = styled.div`
  border-radius: 34.5px;
  height: 10px;
  width: 10px;
`;

// New close button container (80x80)
export const CloseContainer = styled.div`
  height: 80px;
  width: 80px;
  position: absolute;
  top: 0;
  right: 13px;
  z-index: 100;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 1024px) {
    right: 0;
  }
`;


// The small X inside (18x18)
export const CloseXIcon = styled.img`
  width: 18px;
  height: 18px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
`;

// The background image (fills container)
export const CloseBackground = styled.img`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
`;


export const Close = styled.img`
  height: 60px;
  width: 60px;
  position: absolute;
  z-index: 100;

  align-self: flex-end;
  cursor: pointer;
`;



export const UpperWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 30px;
  margin: 20px 0 30px;

 
`;

export const ContentWrapper = styled.div`
  padding: 25px 80px 20px 45px;
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
  height: 90%;
  color: white;
  margin: 10px 10px 10px 0;
  border-right: 5px double var(--highlight);
  border-bottom: 5px double var(--highlight);
  border-top: 5px double var(--highlight);
`;

export const InfoWrapper = styled.div`
  background-color: var(--bg-dark-blue);
  border-radius: 10px;
  padding: 20px;
  text-align: justify;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &.info-wrapper2 {
    width: 100%; /* Make it match parent (same as description) */
    max-width: none; /* Remove any max-width restriction */
    height: 135px;
  }
`;




export const DifficultyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

export const ButtonItemWrapper = styled.div`
  position: relative;
`;

export const DifficultyButton = styled.button`
  background-color: #3e626a;
  border: none;
  border-radius: 5px;
  height: 42px;
  width: 138px;
  cursor: pointer;

  position: relative;
  z-index: 10;

  margin-top: 3px;
  margin-left: 2px;
`;

export const YellowBackground = styled.img`
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100%;

  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
`;

export const PointsInfoWrapper = styled.div`
  background-color: #3e626a;
  border-radius: 10px;
  padding: 20px 0;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;

export const Points = styled.div`
  background-color: var(--highlight);
  border-radius: 50%;
  width: 48px;
  height: 48px;
  font-family: "Source Serif 4";
  text-align: center;
  
`;

export const Icon = styled.img`
  width: ${(props) => props.iconWidth ?? "14px"};
  height: ${(props) => props.iconHeight ?? "14px"};
`;

export const RowItems = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

export const DescriptionWrapper = styled.div`
  background-color: var(--bg-dark-blue);
  border-radius: 10px;

  padding: 10px 10px 10px 30px;
`;

export const StyledSimpleBar = styled(SimpleBar)`
  max-height: 150px;
  padding-right: 40px;
  padding-bottom: 20px;

  /* Vertical track */
  .simplebar-track.simplebar-vertical {
    background: var(--text-dark);
    border-radius: 20px;
    width: 10px;
  }

  /* Hide horizontal track entirely */
  .simplebar-track.simplebar-horizontal {
    display: none !important;
  }

  /* SCROLLBAR THUMB base */
  .simplebar-scrollbar::before {
    content: '';
    display: block;
    height: 100%;
    background-color:rgb(255, 255, 255); /* force visible */
    border-radius: 20px;
    opacity: 1; /* force it to show */
    transition: opacity 0.2s linear;
  }

  /* Container scrollbar for extra control */
  .simplebar-scrollbar {
    width: 100%;
    border: none;
    background: transparent;
  }

  /* Make sure it's visible when needed */
  .simplebar-track.simplebar-vertical .simplebar-scrollbar.simplebar-visible::before {
    opacity: 1 !important;
  }
`;




// export const ScrollBar = styled.div`
//   max-height: 150px;
//   overflow-y: auto;
//   padding-right: 40px;
//   padding-bottom: 20px;

//   /* Firefox */
//   scrollbar-width: thin;
//   scrollbar-color: var(--text-light) var(--text-dark);

//   /* WebKit Browsers (Chrome, Safari, Brave, Edge) */
//   &::-webkit-scrollbar {
//     width: 8px;
//     height: 8px;
//   }

//   &::-webkit-scrollbar-track {
//     background: var(--text-dark);
//     border-radius: 20px;
//   }

//   &::-webkit-scrollbar-thumb {
//     background-color: var(--text-light);
//     border-radius: 20px;
//     border: 2px solid transparent;
//     background-clip: content-box;
//   }

//   /* Remove arrows/buttons */
//   &::-webkit-scrollbar-button,
//   &::-webkit-scrollbar-button:single-button,
//   &::-webkit-scrollbar-button:increment,
//   &::-webkit-scrollbar-button:decrement {
//     display: none;
//     width: 0;
//     height: 0;
//   }

//   &::-webkit-scrollbar-corner {
//     background: var(--text-dark);
//   }

//   /* Firefox (additional attempt, limited effect) */
//   scrollbar-color: var(--text-light) var(--text-dark);

//   & {
//     scrollbar-width: thin;
//   }

//   /* Firefox pseudo-element arrows have no CSS hooks — this has **no visual effect** but included per your request */
//   &::-moz-scrollbar-button {
//     width: 0.5px;
//     height: 0.5px;
//   }
// `;



export const TextWrapper = styled.div`
  text-align: justify;
  overflow: hidden;
  height: 100%;
`;

export const SidePageIcon = styled.img`
  position: absolute;
  bottom: 0;
  right: 0;
`;

export const Spinner = styled.div`
  position: relative;
  width: 400px;
  top: 45%;

  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  &::after {
    content: "";
    width: 48px;
    height: 48px;
    border: 5px solid var(--highlight);
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;

    position: absolute;
    top: 50%;
    left: 45%;

    z-index: 200;
  }

  &::before {
    content: "";

    background-color: white;
    opacity: 0.4;
    width: 100%;
    height: 100%;

    position: absolute;
    top: 0;
    left: 0;
    z-index: 199;
  }
`;
